import React from "react";
import Layout from "../components/Layout";
import styled from 'styled-components';
import bgImage from '../assets/images/home-background.jpg'
import Form from '../components/Form';

const QuoteStyles = styled.div`
  
  padding: 80px 40px 20px 40px;
    
  :before {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    opacity: 0.125;
    background-image: url(${bgImage});
    background-repeat: repeat;
    background-position: 50% 0;
    background-size: cover;
    background-attachment: fixed;
  }

  .medium {
    font-family: Roboto-Medium;
  }

  @media screen and (max-width: 1000px) {
    padding: 60px 20px 20px 20px;
  }
`;

export default function Quote() {
  return <Layout>
    <QuoteStyles>
      <p className="medium">For a free, no-obligation quote on your translation or localization project, please fill in the form below and submit. We will reply with a quotation within 48 hours of receipt. If you have any other questions regarding this quote form or any other concerns, please email us at: <a href="mailto:quotes@transnetmultilingual.ca">quotes@transnetmultilingual.ca</a></p>
      <Form />
    </QuoteStyles>
  </Layout>
}